// THEME FILES
// -----------
// VENDOR FILES
// -----------
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js';

// CUSTOM CODE
// -----------
import { initDesktopMenu, initMobileMenu } from './modules/menu.js';
import { initCardsDisciplineGrid } from './modules/cards-discipline-grid.js';
import { initGranteeDirectoryAccordion } from './modules/grantee-directory-accordion.js';
import { initFooterSignupForm } from './modules/footer-signup.js';
import { initQueryPagination } from './modules/query-pagination.js';
import { initHeroVideo } from './modules/video.js';
import { initImpactImageCarousel } from './modules/impact-image-carousel.js';
import { initSkipLink } from './modules/accessibility.js';

/**
 * Initialize all theme functionality
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
	initDesktopMenu();
	initMobileMenu();
	initCardsDisciplineGrid();
	initGranteeDirectoryAccordion();
	initFooterSignupForm();
	initQueryPagination();
	initImpactImageCarousel();
	initHeroVideo();
	initSkipLink();
});
